import { useCallback, useEffect, useRef } from "react";

// TODO Remove once iframe is removed for data-explorer
const LAST_VIEWED_DASHBOARD_KEY = "lastViewedDashboard";

/**
 * Sends the last viewed dashboard ID to the Ask iframe via postMessage
 * once the iframe signals it's ready (ASK_READY).
 * No-ops for non-Ask iframes.
 */
const useSendLastViewedDashboard = (iframeId: string) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const sendDashboardId = useCallback(() => {
    const dashboardId = localStorage.getItem(LAST_VIEWED_DASHBOARD_KEY);
    if (dashboardId) {
      iframeRef.current?.contentWindow?.postMessage(
        { type: "LAST_VIEWED_DASHBOARD", dashboardId },
        "*",
      );
    }
  }, []);

  useEffect(() => {
    if (iframeId !== "Ask") return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "ASK_READY") {
        sendDashboardId();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [iframeId, sendDashboardId]);

  return iframeRef;
};

export default useSendLastViewedDashboard;
